// extracted by mini-css-extract-plugin
export default {"iconColor":"#44cc94","column":"column__3oiYw","content":"content__1zLmL","headerTitle":"headerTitle__17Wqq","iconContainer":"iconContainer__3OO49","headerContainer":"headerContainer__3tHWD","subHeaderContainer":"subHeaderContainer__3gMgP","bankDetails":"bankDetails__2sR00","largeSize":"largeSize__1WFaz","smallSize":"smallSize__mVa8q","priceAmount":"priceAmount__1FrjJ","priceTTC":"priceTTC__3_Eu7"};
    if(module.hot) {
      // 1713425460721
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  